'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'door-open';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f52b';
var svgPathData = ['M80 86.2L80 496l16 0 208 0 0-452.9c0-15-12.1-27.1-27.1-27.1c-2.1 0-4.1 .2-6.1 .7L104.8 55C90.3 58.4 80 71.3 80 86.2zM200 256c0-10.4 3.2-20.1 8.6-27.4s13.7-12.6 23.4-12.6s17.9 5.3 23.4 12.6s8.6 17 8.6 27.4s-3.2 20.1-8.6 27.4s-13.7 12.6-23.4 12.6s-17.9-5.3-23.4-12.6s-8.6-17-8.6-27.4z', 'M304 496L96 496l-16 0L80 86.2C80 71.3 90.3 58.4 104.8 55l166-38.3c2-.5 4-.7 6.1-.7c15 0 27.1 12.1 27.1 27.1L304 496zM64 86.2L64 496 8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l56 0 16 0 16 0 208 0 16 0 0-16 0-452.9C320 19.3 300.7 0 276.9 0c-3.3 0-6.5 .4-9.7 1.1l-166 38.3C79.4 44.4 64 63.8 64 86.2zM472 80c13.3 0 24 10.7 24 24l0 400c0 4.4 3.6 8 8 8l64 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-56 0 0-392c0-22.1-17.9-40-40-40L352 64l0 16 120 0zM232 216c-9.7 0-17.9 5.3-23.4 12.6s-8.6 17-8.6 27.4s3.2 20.1 8.6 27.4s13.7 12.6 23.4 12.6s17.9-5.3 23.4-12.6s8.6-17 8.6-27.4s-3.2-20.1-8.6-27.4s-13.7-12.6-23.4-12.6zm-16 40c0-7.2 2.2-13.5 5.4-17.8s7-6.2 10.6-6.2s7.4 1.9 10.6 6.2s5.4 10.6 5.4 17.8s-2.2 13.5-5.4 17.8s-7 6.2-10.6 6.2s-7.4-1.9-10.6-6.2s-5.4-10.6-5.4-17.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorOpen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;